import React from 'react';
import { Wallet, Users, AlertCircle } from 'lucide-react';
import DepositAddressManager from '../../components/admin/DepositAddressManager';
import { useAdminUsersWithCustomAddresses } from '../../hooks/useAdminRealtime';

const PlatformDepositAddresses = () => {
  const { usersWithCustomAddresses, count } = useAdminUsersWithCustomAddresses();

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-xl sm:text-2xl font-bold text-white">Platform Deposit Addresses</h1>
        <p className="text-gray-400 text-sm">Manage default deposit addresses for all users</p>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="bg-gray-900 rounded-xl p-6 border border-gray-800">
          <div className="flex items-center space-x-3 mb-2">
            <div className="p-3 bg-purple-500/20 rounded-lg border border-purple-500/30">
              <Wallet className="h-6 w-6 text-purple-400" />
            </div>
            <div>
              <p className="text-gray-400 text-sm">Platform Addresses</p>
              <p className="text-white text-2xl font-bold">8 Cryptocurrencies</p>
            </div>
          </div>
          <p className="text-xs text-gray-400">
            Default addresses used by all users without custom addresses
          </p>
        </div>

        <div className="bg-gray-900 rounded-xl p-6 border border-gray-800">
          <div className="flex items-center space-x-3 mb-2">
            <div className="p-3 bg-blue-500/20 rounded-lg border border-blue-500/30">
              <Users className="h-6 w-6 text-blue-400" />
            </div>
            <div>
              <p className="text-gray-400 text-sm">Custom Addresses</p>
              <p className="text-white text-2xl font-bold">{count} Users</p>
            </div>
          </div>
          <p className="text-xs text-gray-400">
            Users with individually assigned deposit addresses
          </p>
        </div>
      </div>

      {/* Info Banner */}
      <div className="bg-blue-500/10 border border-blue-500/30 rounded-lg p-4">
        <div className="flex items-start space-x-3">
          <AlertCircle className="h-5 w-5 text-blue-400 flex-shrink-0 mt-0.5" />
          <div>
            <p className="text-blue-400 font-semibold mb-1">Real-Time Synchronization</p>
            <p className="text-sm text-gray-300">
              Changes to platform addresses sync instantly with all user deposit pages. Users with custom addresses will continue to see their assigned addresses.
            </p>
          </div>
        </div>
      </div>

      {/* Platform Address Manager */}
      <div className="bg-gray-900 rounded-xl border border-gray-800 p-6">
        <DepositAddressManager userId={null} userEmail={null} />
      </div>

      {/* Users with Custom Addresses */}
      {count > 0 && (
        <div className="bg-gray-900 rounded-xl border border-gray-800 p-6">
          <h3 className="text-white font-bold mb-4">Users with Custom Addresses ({count})</h3>
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {usersWithCustomAddresses.map((user) => (
              <div
                key={user.user_id}
                className="flex items-center justify-between p-3 bg-gray-800 rounded-lg hover:bg-gray-700 transition-colors"
              >
                <div>
                  <p className="text-white font-semibold text-sm">{user.name || 'N/A'}</p>
                  <p className="text-gray-400 text-xs">{user.email}</p>
                </div>
                <div className="flex items-center space-x-2">
                  <span className="px-2 py-1 rounded-full text-xs font-semibold bg-purple-500/20 text-purple-400">
                    Custom
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default PlatformDepositAddresses;
